import { render, staticRenderFns } from "./ChangePaymentCardModal.vue?vue&type=template&id=04096b06&"
import script from "./ChangePaymentCardModal.vue?vue&type=script&lang=ts&"
export * from "./ChangePaymentCardModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports